import { Record } from 'immutable';

const keys: Fields = {
  minutes: '0',
  seconds: '0',
};

interface Fields {
  minutes: string;
  seconds: string;
}

export default class YoutubeVideoDuration extends Record<Fields>(keys) {}
